/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PatchProductsRequestInnerAllOfSchedulesInnerDaysInner } from './PatchProductsRequestInnerAllOfSchedulesInnerDaysInner';
import {
    PatchProductsRequestInnerAllOfSchedulesInnerDaysInnerFromJSON,
    PatchProductsRequestInnerAllOfSchedulesInnerDaysInnerFromJSONTyped,
    PatchProductsRequestInnerAllOfSchedulesInnerDaysInnerToJSON,
    PatchProductsRequestInnerAllOfSchedulesInnerDaysInnerToJSONTyped,
} from './PatchProductsRequestInnerAllOfSchedulesInnerDaysInner';

/**
 * 
 * @export
 * @interface GetOrganizationCombo200ResponseSchedulesInner
 */
export interface GetOrganizationCombo200ResponseSchedulesInner {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCombo200ResponseSchedulesInner
     */
    id: string;
    /**
     * 
     * @type {Array<PatchProductsRequestInnerAllOfSchedulesInnerDaysInner>}
     * @memberof GetOrganizationCombo200ResponseSchedulesInner
     */
    days: Array<PatchProductsRequestInnerAllOfSchedulesInnerDaysInner>;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCombo200ResponseSchedulesInner
     */
    hourFrom: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCombo200ResponseSchedulesInner
     */
    hourTo: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationCombo200ResponseSchedulesInner
     */
    comboId?: string | null;
}

/**
 * Check if a given object implements the GetOrganizationCombo200ResponseSchedulesInner interface.
 */
export function instanceOfGetOrganizationCombo200ResponseSchedulesInner(value: object): value is GetOrganizationCombo200ResponseSchedulesInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('days' in value) || value['days'] === undefined) return false;
    if (!('hourFrom' in value) || value['hourFrom'] === undefined) return false;
    if (!('hourTo' in value) || value['hourTo'] === undefined) return false;
    return true;
}

export function GetOrganizationCombo200ResponseSchedulesInnerFromJSON(json: any): GetOrganizationCombo200ResponseSchedulesInner {
    return GetOrganizationCombo200ResponseSchedulesInnerFromJSONTyped(json, false);
}

export function GetOrganizationCombo200ResponseSchedulesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrganizationCombo200ResponseSchedulesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'days': ((json['days'] as Array<any>).map(PatchProductsRequestInnerAllOfSchedulesInnerDaysInnerFromJSON)),
        'hourFrom': json['hourFrom'],
        'hourTo': json['hourTo'],
        'comboId': json['comboId'] == null ? undefined : json['comboId'],
    };
}

export function GetOrganizationCombo200ResponseSchedulesInnerToJSON(json: any): GetOrganizationCombo200ResponseSchedulesInner {
    return GetOrganizationCombo200ResponseSchedulesInnerToJSONTyped(json, false);
}

export function GetOrganizationCombo200ResponseSchedulesInnerToJSONTyped(value?: GetOrganizationCombo200ResponseSchedulesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'days': ((value['days'] as Array<any>).map(PatchProductsRequestInnerAllOfSchedulesInnerDaysInnerToJSON)),
        'hourFrom': value['hourFrom'],
        'hourTo': value['hourTo'],
        'comboId': value['comboId'],
    };
}

